/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
import { useEffect, useRef, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, Grid, Snackbar, Typography, Box } from '@mui/material';
import { AutoCompleteProduto, IVFormErrors, VFieldMoneyNumber2, VFieldMoneyNumber4dn, VFieldMoneynumber, VForm, VTextField, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { v4 as uuidv4 } from 'uuid';

interface IFormData {
  iditens: string;
  idprodutos: string;
  idref: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  ean?: string;
  subtotal: number;
  total: number;
  desconto: number;
  voutros: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  descricao: string;
  status?: number;
}

// Dados retornados quando é uma devolução parcial
export interface IDevolucaoItem {
  iditens: string;          // novo UUID gerado para o item devolvido
  iditensOriginal: string;  // UUID original do item na venda
  idmov: string;
  idprodutos: string;
  un: string;
  qtde: number;
  qtds: number;             // quantidade devolvida
  qtdsOriginal: number;     // quantidade original do item
  subtotal: number;
  tipo: number;
  idref: string;
  preco: number;
  descricao?: string;
}
export interface ConfirmationDialogRawProps {
  id: string;
  decimais?: number;
  est: boolean;
  reff?: boolean;
  value: string;
  open: boolean;
  status?: number;
  dados?: IFormData;
  modoDevolucao?: boolean;   // <-- nova prop
  idmov?: string;            // <-- necessário para montar IDevolucaoItem
  onDados: (dados: IFormData) => void;
  onDevolucao?: (item: IDevolucaoItem) => void; // <-- callback de devolução
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'iditens' | 'idprodutos' | 'descricao' | 'filtro' | 'qtde' | 'total' | 'desconto' | 'voutros' | 'idref'>> = yup.object().shape({
  qtds: yup.number().required().default(0),
  preco: yup.number().required().moreThan(0),
  subtotal: yup.number().required(),
  un: yup.string().required(),
  ean: yup.string().optional(),
  status: yup.number().required().default(1),
  marca: yup.string().optional(),
  referencia: yup
    .string()
    .transform((value) => (value === null ? '' : value))
    .optional()
    .default(''),
});

export const DialogVendaEdit: React.FC<ConfirmationDialogRawProps> = (props) => {
  const { formRef, save } = useVForm();
  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState('');
  const [idprodd, setIdprodd] = useState('');
  const [idref, setIdref] = useState('');
  const [quan, setQuan] = useState(0);
  const [descricao, setdescricao] = useState('');
  const [openRefError, setOpenRefError] = useState(false);

  // Estado exclusivo do modo devolução
  const [qtdDevolucao, setQtdDevolucao] = useState<number>(0);
  const [qtdDevolucaoTexto, setQtdDevolucaoTexto] = useState<string>('');
  const [erroDevolucao, setErroDevolucao] = useState('');
  const qtdDevolucaoInputRef = useRef<HTMLInputElement>(null);

  const itensnovo = {
    filtro: 'descricao',
    idprodutos: '',
    qtde: 0,
    qtds: 1,
    preco: 0,
    referencia: '',
    subtotal: 0,
    desconto: 0,
    voutros: 0,
    total: 0,
    un: '',
  };

  const resetProduto = () => {
    setIdprodd('');
    setIdref('');
    setdescricao('');
    setQuan(0);
    formRef.current?.setData({
      filtro: 'descricao',
      idprodutos: '',
      qtds: 1,
      preco: 0,
      subtotal: 0,
      desconto: 0,
      voutros: 0,
      total: 0,
      un: '',
      referencia: '',
    });
  };

  const dec = props.decimais ?? 2;

  const formatarNumero = (valor: number): string => {
    return valor.toFixed(dec).replace('.', ',');
  };

  const parseNumero = (valor: unknown): number => {
    if (typeof valor === 'number') return valor;
    if (typeof valor !== 'string') return 0;
    return Number(valor.replace(/\./g, '').replace(',', '.')) || 0;
  };

  const roundTo = (value: number): number => {
    const factor = Math.pow(10, dec);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  };

  const formatMoneyBR = (value: number | string | null | undefined): string => {
    if (value === null || value === undefined || value === '') return '0,00';
    let numberValue: number;
    if (typeof value === 'string') {
      const clean = value.replace(/\./g, '').replace(',', '.');
      numberValue = Number(clean);
    } else {
      numberValue = value;
    }
    if (isNaN(numberValue)) return '0,0000';
    return numberValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });
  };

  // Mesma máscara usada pelos demais campos numéricos (VFieldMoneynumber)
  const formatQtdDevolucaoMascara = (val: string): string => {
    val = val.replace(/\D/g, '');
    val = val.replace(/(\d)(\d{2})$/, '$1,$2');
    val = val.replace(/(?=(\d{3})+(\D))\B/g, '.');
    return val;
  };

  const formatQtdDevolucaoNumero = (val: string): number => {
    if (!val) return 0;
    const clean = val.replace(/\./g, '').replace(',', '.');
    return Number(clean) || 0;
  };

  useEffect(() => {
    if (props.id === 'novo') {
      setIdprodd('');
      setdescricao('');
      setValue('');
      setId('');
      setQtdDevolucao(0);
      setQtdDevolucaoTexto('');
      setErroDevolucao('');
      formRef.current?.setData(itensnovo);
    } else {
      if (props.dados && typeof props.dados === 'object') {
        const totalFormatado = formatMoneyBR(props.dados.total);
        const precoFormatado = formatMoneyBR(props.dados.preco);
        setIdprodd(props.dados.idprodutos);
        setdescricao(props.dados.descricao);
        setQuan(props.dados.status === 2 ? 0 : props.dados.qtds);
        setIdref(props.dados.idref);
        setQtdDevolucao(0);
        setQtdDevolucaoTexto('');
        setErroDevolucao('');
        formRef.current?.setData({
          ...props.dados,
          total: totalFormatado,
          preco: precoFormatado,
          filtro: 'descricao',
        });
      }
    }
  }, [id, formRef, open]);

  useEffect(() => {
    if (open && props.modoDevolucao) {
      const timer = setTimeout(() => {
        qtdDevolucaoInputRef.current?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [open, props.modoDevolucao]);

  const handleProduto = (valor: string | undefined) => {
    if (valor !== undefined) setdescricao(valor);
  };

  const handleun = (valor: string | undefined) => {
    formRef.current?.setFieldValue('un', valor ?? '');
  };

  const handlereferencia = (valor: string | undefined) => {
    formRef.current?.setFieldValue('referencia', valor ?? '');
  };

  const handlidprod = (valor: string | undefined) => {
    if (!valor) { resetProduto(); return; }
    setIdprodd(valor);
  };

  const handlequan = (valor: number | undefined) => {
    if (valor !== undefined && valor !== null) setQuan(valor);
  };

 const handleConfirmarDevolucao = () => {
  const qtdOriginal = Number(props.dados?.qtds || 0);
  const novoIditens = uuidv4(); // novo UUID exclusivo para o item devolvido

  if (qtdDevolucao <= 0) {
    setErroDevolucao('Informe uma quantidade maior que zero.');
    return;
  }
  if (qtdDevolucao > qtdOriginal) {
    setErroDevolucao(
      `A quantidade devolvida (${qtdDevolucao}) não pode ser maior que a quantidade do item (${qtdOriginal}).`
    );
    return;
  }

  setErroDevolucao('');

  if (props.onDevolucao && props.dados) {
    props.onDevolucao({
      iditens: novoIditens,           // novo id para o registro de devolução
      iditensOriginal: props.dados.iditens, // id original para localizar na tabela
      idmov: props.idmov ?? '',
      idprodutos: props.dados.idprodutos,
      un: props.dados.un,
      qtde: 0,
      qtds: qtdDevolucao,
      qtdsOriginal: qtdOriginal,
      subtotal: props.dados.subtotal,
      tipo: 2,
      idref: props.dados.idref,
      preco: props.dados.preco,
      descricao: props.dados.descricao,
    });
  }

  onClose(value);
};

  // Confirmação no modo edição normal
  const handleSave = (dados: IFormData) => {
    const DadosValidados = { ...dados };
    formValidationSchema
      .validate(DadosValidados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);

        if (props.reff === true && (!idref || idref === '')) {
          setOpenRefError(true);
          setIsLoading(false);
          return;
        }

        if (props.est) {
          const qtdInformada = Number(dadosValidados.qtds);
          if (props.status === 2) {
            if (qtdInformada > quan) {
              formRef.current?.setFieldError('qtds', `Quantidade maior que o estoque disponível (${quan})`);
              setIsLoading(false);
              return;
            }
          }
          if (props.status === 1) {
            const qtdAnterior = Number(props.dados?.qtds || 0);
            const qtdAcrescentada = qtdInformada - qtdAnterior;
            if (qtdAcrescentada > 0 && qtdAcrescentada > quan) {
              formRef.current?.setFieldError('qtds', `Você adicionou ${qtdAcrescentada}, mas o estoque disponível é ${quan}`);
              setIsLoading(false);
              return;
            }
          }
        }

        const qtdAnterior = Number(props.dados?.qtds || 0);
        const qtdAtual = Number(dadosValidados.qtds);
        const novoStatus = qtdAtual > qtdAnterior ? 2 : 1;

        const dadosComIdProd = {
          ...dadosValidados,
          descricao: descricao,
          idprodutos: idprodd,
          idref: idref,
          status: novoStatus,
        };

        props.onDados({
          iditens: props.id,
          qtde: 0,
          desconto: dados.desconto,
          voutros: dados.voutros,
          total: dados.total,
          filtro: '',
          ...dadosComIdProd,
        });

        onClose(value);
        setIsLoading(false);
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach((error) => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleCancel = () => {
    setIdprodd('');
    setdescricao('');
    setValue('');
    setId('');
    setIdref('');
    setQtdDevolucao(0);
    setQtdDevolucaoTexto('');
    setErroDevolucao('');
    formRef.current?.setData(itensnovo);
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    } else {
      setId(valueProp);
    }
  }, [valueProp, open]);

  const handleQtd = (valor: number | undefined) => {
    if (valor != null) {
      const data = formRef.current?.getData();
      const qtd = Number(valor);
      const preco = parseNumero(data?.preco);
      const totalBruto = qtd * preco;
      const totalArredondado = roundTo(totalBruto);
      formRef.current?.setFieldValue('subtotal', formatarNumero(totalArredondado));
    }
  };

  const qtdOriginal = Number(props.dados?.qtds || 0);

  return (
    <Dialog
      open={open}
      {...other}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
          overflow: 'hidden',
        },
      }}
    >
      <Snackbar
        open={openRefError}
        autoHideDuration={3000}
        onClose={() => setOpenRefError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="warning" variant="filled" onClose={() => setOpenRefError(false)} sx={{ width: '100%' }}>
          Este produto exige referência para ser adicionado
        </Alert>
      </Snackbar>

      {/* Cabeçalho */}
      <Grid
        container
        direction="column"
        sx={{
          px: 3, pt: 3, pb: 2,
          borderBottom: 1,
          borderColor: 'divider',
          position: 'relative',
          backgroundColor: props.modoDevolucao
            ? 'warning.light'
            : 'background.paper',
        }}
      >
        <Grid container alignItems="center" spacing={2}>
          <Grid
            item
            sx={{
              width: 48, height: 48,
              borderRadius: '12px',
              backgroundColor: props.modoDevolucao
                ? 'warning.main'
                : (theme) => theme.palette.primary.main + '14',
              display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: 22,
            }}
          >
            {props.modoDevolucao ? '↩' : props.id === 'novo' ? '＋' : '✎'}
          </Grid>
          <Grid item xs>
            <strong style={{ fontSize: 18 }}>
              {props.modoDevolucao
                ? 'Devolução de Item'
                : props.id === 'novo'
                  ? 'Adicionar Item'
                  : 'Editar Item'}
            </strong>
            <div style={{ fontSize: 14, color: '#666', marginTop: 4, wordBreak: 'break-word' }}>
              {descricao || 'Selecione um produto'}
            </div>
          </Grid>
        </Grid>
      </Grid>

      <DialogContent sx={{ p: 3 }}>

        {/* ── MODO DEVOLUÇÃO ── */}
        {props.modoDevolucao ? (
          <Grid container spacing={2}>
            {/* Informações somente leitura do item */}
            <Grid item xs={12}>
              <Box sx={{
                p: 2, borderRadius: 2,
                backgroundColor: 'action.hover',
                border: '1px solid',
                borderColor: 'divider',
              }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Produto
                </Typography>
                <Typography variant="body1" fontWeight={600}>
                  {props.dados?.descricao || '—'}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{
                p: 2, borderRadius: 2,
                backgroundColor: 'action.hover',
                border: '1px solid',
                borderColor: 'divider',
                textAlign: 'center',
              }}>
                <Typography variant="body2" color="text.secondary">
                  Qtd. original
                </Typography>
                <Typography variant="h6" fontWeight={700}>
                  {qtdOriginal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box sx={{
                p: 2, borderRadius: 2,
                backgroundColor: 'action.hover',
                border: '1px solid',
                borderColor: 'divider',
                textAlign: 'center',
              }}>
                <Typography variant="body2" color="text.secondary">
                  Preço unitário
                </Typography>
                <Typography variant="h6" fontWeight={700}>
                  {(props.dados?.preco ?? 0).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 4,
                  })}
                </Typography>
              </Box>
            </Grid>

            {/* Campo de quantidade devolvida */}
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                Quantidade devolvida <span style={{ color: 'red' }}>*</span>
              </Typography>
              <input
                ref={qtdDevolucaoInputRef}
                type="text"
                inputMode="decimal"
                autoFocus
                value={qtdDevolucaoTexto}
                onChange={(e) => {
                  const masked = formatQtdDevolucaoMascara(e.target.value);
                  const val = formatQtdDevolucaoNumero(masked);

                  setQtdDevolucaoTexto(masked);
                  setQtdDevolucao(val);

                  if (val > qtdOriginal) {
                    setErroDevolucao(`Máximo permitido: ${qtdOriginal}`);
                  } else if (val <= 0 && masked !== '') {
                    setErroDevolucao('Informe uma quantidade maior que zero.');
                  } else {
                    setErroDevolucao('');
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleConfirmarDevolucao();
                  }
                }}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  fontSize: 16,
                  borderRadius: 8,
                  border: erroDevolucao
                    ? '1.5px solid #d32f2f'
                    : '1.5px solid #bdbdbd',
                  outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
              {erroDevolucao && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
                  {erroDevolucao}
                </Typography>
              )}
            </Grid>

            {/* Preview da qtd restante */}
            {qtdDevolucao > 0 && qtdDevolucao <= qtdOriginal && (
              <Grid item xs={12}>
                <Box sx={{
                  p: 1.5, borderRadius: 2,
                  backgroundColor: 'info.light',
                  border: '1px solid',
                  borderColor: 'info.main',
                }}>
                  <Typography variant="body2" color="info.dark">
                    Após a devolução, a quantidade restante será:{' '}
                    <strong>
                      {(qtdOriginal - qtdDevolucao).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </strong>
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>

        ) : (
          /* ── MODO EDIÇÃO NORMAL ── */
          <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <AutoCompleteProduto
                  isExternalLoading={true}
                  descricao={handleProduto}
                  idproduto={handlidprod}
                  quan={handlequan}
                  referencia={handlereferencia}
                  un={handleun}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <VFieldMoneynumber
                  fullWidth
                  size="small"
                  name="qtds"
                  label="Quantidade"
                  calcular={handleQtd}
                  disabled={false}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <VTextField fullWidth size="small" name="un" label="UN" disabled />
              </Grid>
              <Grid item xs={6} md={6}>
                <VTextField
                  fullWidth size="small" name="referencia" label="Referência"
                  disabled
                  value={formRef.current?.getFieldValue('referencia') || ''}
                />
              </Grid>
              {props.decimais === 4 && (
                <Grid item xs={6} md={6}>
                  <VFieldMoneyNumber4dn fullWidth size="small" name="preco" label="Valor Unitário" disabled={true} />
                </Grid>
              )}
              {props.decimais === 2 && (
                <Grid item xs={6} md={6}>
                  <VFieldMoneyNumber2 fullWidth size="small" name="preco" label="Valor Unitário" disabled={true} />
                </Grid>
              )}
              {props.decimais === 4 && (
                <Grid item xs={12} md={6}>
                  <VFieldMoneyNumber4dn fullWidth size="small" name="subtotal" label="Valor Total" disabled />
                </Grid>
              )}
              {props.decimais === 2 && (
                <Grid item xs={12} md={6}>
                  <VFieldMoneyNumber2 fullWidth size="small" name="subtotal" label="Valor Total" disabled />
                </Grid>
              )}
            </Grid>
          </VForm>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2.5, borderTop: 1, borderColor: 'divider', backgroundColor: 'background.default' }}>
        <Button
          variant="outlined"
          color="error"
          onClick={handleCancel}
          sx={{ borderRadius: '8px', textTransform: 'none' }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color={props.modoDevolucao ? 'warning' : 'primary'}
          disabled={props.modoDevolucao
            ? (qtdDevolucao <= 0 || qtdDevolucao > qtdOriginal)
            : false}
          onClick={props.modoDevolucao ? handleConfirmarDevolucao : save}
          sx={{ borderRadius: '8px', textTransform: 'none', px: 3 }}
        >
          {props.modoDevolucao ? 'Confirmar Devolução' : 'Confirmar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};